import { render, staticRenderFns } from "./setcode.vue?vue&type=template&id=2ba4a538&scoped=true"
import script from "./setcode.vue?vue&type=script&lang=js"
export * from "./setcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4a538",
  null
  
)

export default component.exports